<app-shared-notify-chip status="error">
  <ogs-m3-icon prefix="fal" icon="exclamation-triangle" />
  <app-shared-notify-chip-value>
    {{"Der Benutzername oder das Passwort sind nicht korrekt." | translate: "paragraph-invalid-credentials"}}
  </app-shared-notify-chip-value>
</app-shared-notify-chip>
